/* Aurora customizer: business card, front and back at once. Proportions only (standard card ratio). */
(function () {
  'use strict';
  var L = window.AuroraCZ;

  // standard business-card ratio 90 : 54; the numbers are canvas px, not product sizes
  var LONG = 520, SHORT = 312;

  function init(root) {
    var t = L.i18n(root);
    var canvas = root.querySelector('[data-cz-canvas]');
    var ctx = canvas.getContext('2d');
    var empty = root.querySelector('[data-cz-empty]');
    var status = root.querySelector('[data-cz-status]');
    var hint = root.querySelector('[data-cz-hint]');
    var dlBtn = root.querySelector('[data-cz-download]');
    var mailLink = root.querySelector('[data-cz-mail]');
    var mail = root.getAttribute('data-mail') || '';
    var W = canvas.width, H = canvas.height;

    var st = {
      sel: 'front', orient: 'landscape', round: true, base: '#f4f1ea', guides: false, nfc: false,
      side: {
        front: { pic: null, pl: new L.Placement('cover') },
        back: { pic: null, pl: new L.Placement('cover') }
      }
    };

    function say(m, k) { L.say(status, m, k); }

    function rects() {
      var land = st.orient === 'landscape';
      var w = land ? LONG : SHORT, h = land ? SHORT : LONG;
      return land
        ? { front: { x: 70, y: 70, w: w, h: h }, back: { x: 410, y: 378, w: w, h: h } }
        : { front: { x: 130, y: 80, w: w, h: h }, back: { x: 520, y: 160, w: w, h: h } };
    }
    function radius() { return st.round ? 22 : 2; }
    function ink() {
      var n = parseInt(st.base.slice(1), 16);
      var lum = ((n >> 16) & 255) * 0.299 + ((n >> 8) & 255) * 0.587 + (n & 255) * 0.114;
      return lum > 140 ? 'rgba(20,32,26,0.55)' : 'rgba(245,250,246,0.7)';
    }

    function paintCard(c, key, r, opts) {
      var s = st.side[key];
      c.save();
      if (opts.shadow) { c.shadowColor = 'rgba(15,32,25,0.22)'; c.shadowBlur = 30; c.shadowOffsetY = 14; }
      L.rrect(c, r.x, r.y, r.w, r.h, radius());
      c.fillStyle = st.base; c.fill();
      c.restore();

      if (s.pic) {
        c.save();
        L.rrect(c, r.x, r.y, r.w, r.h, radius()); c.clip();
        L.drawPic(c, s.pic, s.pl, r);
        c.restore();
      } else if (opts.shadow) {
        c.save();
        c.fillStyle = ink(); c.globalAlpha = 0.7;
        c.font = '600 30px "Noto Sans TC","PingFang TC","Microsoft JhengHei",sans-serif';
        c.textAlign = 'center'; c.textBaseline = 'middle';
        c.fillText(key === 'front' ? t.sideFront : t.sideBack, r.x + r.w / 2, r.y + r.h / 2);
        c.restore();
      }

      if (st.nfc && key === 'back') {
        c.save();
        c.strokeStyle = ink(); c.lineWidth = 4; c.lineCap = 'round';
        var cx = r.x + r.w - 62, cy = r.y + r.h - 62;
        [14, 25, 36].forEach(function (rad) { c.beginPath(); c.arc(cx - 20, cy, rad, -0.62, 0.62); c.stroke(); });
        c.restore();
      }

      if (st.guides && opts.shadow) {
        c.save();
        c.setLineDash([8, 6]); c.lineWidth = 1.5; c.strokeStyle = 'rgba(30,201,192,0.9)';
        L.rrect(c, r.x + 26, r.y + 26, r.w - 52, r.h - 52, Math.max(0, radius() - 10)); c.stroke();
        c.restore();
      }

      if (opts.shadow) {
        c.save();
        L.rrect(c, r.x + 0.75, r.y + 0.75, r.w - 1.5, r.h - 1.5, radius());
        c.lineWidth = 1.5; c.strokeStyle = 'rgba(15,32,25,0.16)'; c.stroke();
        if (st.sel === key) {
          c.setLineDash([]);
          L.rrect(c, r.x - 7, r.y - 7, r.w + 14, r.h + 14, radius() + 6);
          c.lineWidth = 3; c.strokeStyle = 'rgba(30,201,192,0.95)'; c.stroke();
        }
        c.restore();
      }
    }

    function paintAll(c, opts) {
      var r = rects();
      paintCard(c, 'front', r.front, opts);
      paintCard(c, 'back', r.back, opts);
    }

    var queued = false;
    function draw() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        ctx.clearRect(0, 0, W, H);
        paintAll(ctx, { shadow: true });
      });
    }

    function anyPic() { return st.side.front.pic || st.side.back.pic; }
    function refreshUI() {
      var cur = st.side[st.sel];
      ctl.bind(cur.pic ? cur.pl : null);
      root.querySelectorAll('[data-side]').forEach(function (b) {
        var on = b.getAttribute('data-side') === st.sel;
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      dlBtn.disabled = !anyPic();
      empty.hidden = !!anyPic();
      hint.hidden = !anyPic();
    }
    function updateMail() {
      var extra = '\n\n' + [L.label(root, '[data-orient].is-on'), L.label(root, '[data-corner].is-on'),
        L.label(root, '[data-base].is-on')].join(' / ') + (st.nfc ? ' / ' + t.nfcLabel : '');
      L.mail(mailLink, mail, t.mailSubject, (t.mailBody || '') + extra);
    }

    var ctl = L.controls(root, draw);

    // upload, one slot per side
    root.querySelectorAll('[data-upload]').forEach(function (drop) {
      var key = drop.getAttribute('data-upload');
      L.bindUpload(drop, drop.querySelector('input'), function (file) {
        L.loadFile(file, t, say, function (pic) {
          st.side[key].pic = pic; st.side[key].pl.reset();
          drop.classList.add('is-filled');
          drop.querySelector('span').textContent = file.name;
          st.sel = key; refreshUI(); draw();
        });
      });
    });

    root.querySelectorAll('[data-side]').forEach(function (b) {
      b.addEventListener('click', function () { st.sel = b.getAttribute('data-side'); refreshUI(); draw(); });
    });
    var orientBtns = root.querySelectorAll('[data-orient]');
    orientBtns.forEach(function (b) { b.addEventListener('click', function () {
      st.orient = b.getAttribute('data-orient'); L.radio(orientBtns, b);
      st.side.front.pl.fx = st.side.front.pl.fy = st.side.back.pl.fx = st.side.back.pl.fy = 0;
      updateMail(); draw(); }); });
    var cornerBtns = root.querySelectorAll('[data-corner]');
    cornerBtns.forEach(function (b) { b.addEventListener('click', function () {
      st.round = b.getAttribute('data-corner') === 'round'; L.radio(cornerBtns, b); updateMail(); draw(); }); });
    var baseBtns = root.querySelectorAll('[data-base]');
    baseBtns.forEach(function (b) { b.addEventListener('click', function () {
      st.base = b.getAttribute('data-base'); L.radio(baseBtns, b); updateMail(); draw(); }); });
    root.querySelectorAll('[data-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-toggle');
        st[k] = !st[k];
        b.classList.toggle('is-on', st[k]); b.setAttribute('aria-pressed', st[k] ? 'true' : 'false');
        updateMail(); draw();
      });
    });

    L.dragger(canvas, {
      pick: function (x, y) {
        var r = rects();
        var hit = ['back', 'front'].filter(function (k) {
          return x >= r[k].x && x <= r[k].x + r[k].w && y >= r[k].y && y <= r[k].y + r[k].h;
        })[0];
        if (hit && hit !== st.sel) { st.sel = hit; refreshUI(); draw(); }
      },
      current: function () {
        var s = st.side[st.sel]; if (!s.pic) return null;
        var r = rects()[st.sel];
        return { pl: s.pl, w: r.w, h: r.h };
      },
      onZoom: function () { ctl.refresh(); },
      onChange: draw
    });

    dlBtn.addEventListener('click', function () {
      if (!anyPic()) return;
      var r = rects(), k = 1.6;
      var x0 = Math.min(r.front.x, r.back.x), y0 = Math.min(r.front.y, r.back.y);
      var x1 = Math.max(r.front.x + r.front.w, r.back.x + r.back.w), y1 = Math.max(r.front.y + r.front.h, r.back.y + r.back.h);
      var out = document.createElement('canvas');
      out.width = Math.round((x1 - x0) * k); out.height = Math.round((y1 - y0) * k);
      var c = out.getContext('2d');
      c.scale(k, k); c.translate(-x0, -y0);
      paintAll(c, { shadow: false });
      L.download(out, (t.fileName || 'aurora-card-preview') + '-' + st.orient + '.png');
    });

    refreshUI(); updateMail(); draw();
  }

  L.boot('[data-aurora-cz-card]', init);
})();
